import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { claimTypes } from './constants'

const ClaimTypeSelector = ({ handleChange, value }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      handleChange={handleChange}
      value={value}
      label={t('Tipo de incidencia')}
      fullWidth
      menuItems={claimTypes.map(ct => ({ label: t(ct.label), value: ct.value }))}
    />
  )
}

export default ClaimTypeSelector
